module.exports = __webpack_public_path__ + "static/img/topbanner.f8bb2908.png";